@let loadListValue = loadList();

<section id="web-loads-map-id" class="web-loads-map" data-testid="landing-loads-map">
  <div class="web-loads-map__header">
    <h2 class="web-loads-map__header-title">
      {{ 'landing.loadsMap.title1' | translate }}
      <span class="web-loads-map__header-title--heightlight">{{
        'landing.loadsMap.titleHighlight' | translate
      }}</span>
    </h2>

    <p class="web-loads-map__header-subtitle">
      {{ 'landing.loadsMap.subtitle' | translate }}
    </p>
  </div>

  <div class="web-loads-map-map">
    <!--    <div class="web-loads-map-zipInput">-->
    <!--      <div class="web-loads-map-zipInput__inner">-->
    <!--        <fr8bot-google-places-picker-white placeholder="Enter zip code (e.g. 60007)" />-->
    <!--        <fr8bot-ui-button-->
    <!--          type="primaryCut"-->
    <!--          size="large"-->
    <!--          class="web-loads-map-zipInput__inner-button"-->
    <!--        >-->
    <!--          See Loads-->
    <!--          <fr8bot-ui-icon postfix-icon name="arrow-down-16" [size]="16" />-->
    <!--        </fr8bot-ui-button>-->
    <!--      </div>-->
    <!--    </div>-->

    <div class="web-loads-map-map__inner">
      @if (!tilesLoaded()) {
        <fr8bot-ui-loading
          data-testid="landing-loads-map-loading"
          class="web-loads-map-map__inner-loading"
          mode="overlay"
          variant="not-transparent"
          [instant]="true"
          animate.leave="tw:skeleton-leave"
        />
      }

      <div class="web-loads-map-map__inner-shadow web-loads-map-map__inner-shadow--top"></div>
      <div class="web-loads-map-map__inner-shadow web-loads-map-map__inner-shadow--bottom"></div>

      <google-map
        class="web-loads-map-map__inner-map"
        [options]="mapOptions"
        (mapInitialized)="onMapReady()"
        (tilesloaded)="tilesLoaded.set(true)"
      >
        <!-- Wait for the map: a clusterer whose map is destroyed while the Maps API loads throws on init -->
        @if (isMapLoaded()) {
          <map-marker-clusterer [renderer]="clusterRenderer" [algorithm]="clusterAlgorithm">
            @for (location of loadListValue; track $index) {
              <map-marker
                [position]="{ lat: location.latitude ?? 0, lng: location.longitude ?? 0 }"
                [options]="markerOptions"
              ></map-marker>
            }
          </map-marker-clusterer>
        }
      </google-map>
    </div>
  </div>

  <div class="web-loads-map-alert">
    <div class="web-loads-map-alert__inner">
      <div
        class="web-loads-map-alert__inner-border web-loads-map-alert__inner-border--top web-loads-map-alert__inner-border--left"
      ></div>
      <div
        class="web-loads-map-alert__inner-border web-loads-map-alert__inner-border--top web-loads-map-alert__inner-border--right"
      ></div>
      <div
        class="web-loads-map-alert__inner-border web-loads-map-alert__inner-border--bottom web-loads-map-alert__inner-border--left"
      ></div>
      <div
        class="web-loads-map-alert__inner-border web-loads-map-alert__inner-border--bottom web-loads-map-alert__inner-border--right"
      ></div>

      <!--        <div class="web-loads-map-alert__inner-text">-->
      <!--          <div class="web-loads-map-alert__inner-text-number">{{ loadListValue?.length }}</div>-->

      <!--          <div class="web-loads-map-alert__inner-text-description">-->
      <!--            active loads-->
      <!--          </div>-->
      <!--        </div>-->

      <fr8bot-ui-button
        type="primaryCut"
        size="large"
        class="web-loads-map-alert__inner-button"
        data-testid="landing-loads-map-cta"
        (click)="openCarrierCabinet.emit()"
      >
        {{ 'landing.loadsMap.button' | translate }}
      </fr8bot-ui-button>
    </div>
  </div>
</section>
